'use strict'

module.exports = require('./js')



//////////////////
// WEBPACK FOOTER
// ./node_modules/iframe-resizer/index.js
// module id = 551
// module chunks = 31